import { render, staticRenderFns } from "./ChangesSaved.vue?vue&type=template&id=2f7b2cb8"
import script from "./ChangesSaved.vue?vue&type=script&lang=ts"
export * from "./ChangesSaved.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports